import { Injectable, Type } from "@angular/core";
import { Routes } from "@angular/router";
import { DynamicRoute, IDynamicRoutesProvider } from "core";
import { Tasks } from "../tasks/tasks";
import { TasksList } from "../tasks-list/tasks-list";
import { TaskDetail } from "../task-detail/task-detail";
import { TASKS_DESCRIBE } from "../constants";

@Injectable({ providedIn: 'root' })
export class TasksRoutesProvider extends IDynamicRoutesProvider {
    override componentMap: Record<string, Type<any>> = {
        'tasks': Tasks,
        'tasks-list': TasksList,
        'task-detail': TaskDetail,
        'task-documents': Tasks,
    };    

    // deve corrispondere all'id nel json della chiamate delle rotte
    override describe(): String {
        return 'tasks';
    }

    override evaluate(dynamicRoute: DynamicRoute[]): Routes {
        return this.buildRoutes(dynamicRoute, TASKS_DESCRIBE);
    }
    // dynamicRoute example:
    // {
    //     "id": "orders-authorization",
    //     "path": "orders-authorization",
    //     "children": [
    //         {
    //             "id": "list",
    //             "path": "list",
    //             "children": []
    //         },
    //         {
    //             "id": "detail",
    //             "path": ":orderId",
    //             "children": [
    //                 {
    //                     "id": "documents",
    //                     "path": "documents",
    //                     "children": []
    //                 }
    //             ]
    //         }
    //     ]
    // },
}